import React, { useState } from "react";
import { Loading } from "../../components/Loading";
import { Header } from "../../components/Header";
import { Button, Table } from "antd";
import useCars from "../../hooks/useCars";
import AddCar from "./AddCar/AddCar";
import EditCar from "./EditCar/EditCar";
import { ContentCard } from "../../components/ContentCard/ContentCard";
import { FilterCar } from "./FilterCar/FilterCar";
import Edit from "../../assets/svg/edit-icon.svg";
import PlateNumberComponent from "../../components/PlateNumberComponent";
import { showManuFactoringYearsByCarModel } from "../../core/utils";

export const Cars = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const {
    loading,
    cars,
    provinces,
    cities,
    setCities,
    brands,
    setBrands,
    models,
    setModels,
    editState,
    setEditState,
    getCars,
    getCarsBrands,
    getCarsModels,
    filters,
    setFilters,
    onChangeFilters,
    onAddCar,
    onAddCarValues,
    onEditCar,
    changePage,
    getCarsReport,
    handleAddCarState,
    addCarStates,
  } = useCars({
    setIsModalOpen,
    isInCarsPage: true,
  });
  const { Column } = Table;

  const checkCarType = (type) => {
    if (!cars) return "";
    return cars?.extra.car_types.find((car_type) => car_type[0] === type)[1];
  };

  const data = [
    {
      id: 101,
      is_active: true,
      car: {
        id: 2001,
        brand: "Toyota",
        brand_id: 501,
        name: "Toyota Camry",
        type: "riding",
        is_jalali: false,
      },
      year: "2023",
      plate_number: "ه ع ب ٤٥٦٧ / H A B 4567",
      city: {
        name: "Riyadh",
        id: 1,
      },
      province: {
        name: "Riyadh",
        id: 1,
      },
      usage: "sedan",
      capacity: 5,
      capacity_unit: "person",
      vin: "4T1BF1FK0HU123456",
    },
    {
      id: 102,
      is_active: true,
      car: {
        id: 2002,
        brand: "Nissan",
        brand_id: 502,
        name: "Nissan Patrol",
        type: "riding",
        is_jalali: false,
      },
      year: "2024",
      plate_number: "ب د س ٢٣٤٥ / B D S 2345",
      city: {
        name: "Jeddah",
        id: 2,
      },
      province: {
        name: "Makkah",
        id: 2,
      },
      usage: "suv",
      capacity: 7,
      capacity_unit: "person",
      vin: "JN1SB0RR1HX789012",
    },
    {
      id: 103,
      is_active: false,
      car: {
        id: 2003,
        brand: "Hyundai",
        brand_id: 503,
        name: "Hyundai Accent",
        type: "riding",
        is_jalali: false,
      },
      year: "2022",
      plate_number: "س ك ل ٠٠١٢ / S K L 0012",
      city: {
        name: "Dammam",
        id: 3,
      },
      province: {
        name: "Eastern Province",
        id: 3,
      },
      usage: "hatchback",
      capacity: 4,
      capacity_unit: "person",
      vin: "KMHCT4AE4GU456789",
    },
    {
      id: 104,
      is_active: true,
      car: {
        id: 2004,
        brand: "Isuzu",
        brand_id: 504,
        name: "Isuzu NPR",
        type: "heavy",
        is_jalali: false,
      },
      year: "2021",
      plate_number: "ج ر د ٧٨٩٠ / J R D 7890",
      city: {
        name: "Mecca",
        id: 4,
      },
      province: {
        name: "Makkah",
        id: 2,
      },
      usage: "flatbed",
      capacity: 3500,
      capacity_unit: "kilogram",
      vin: "JALE4RFE7K234567",
    },
    {
      id: 105,
      is_active: true,
      car: {
        id: 2005,
        brand: "Mercedes-Benz",
        brand_id: 505,
        name: "Mercedes-Benz Sprinter",
        type: "heavy",
        is_jalali: false,
      },
      year: "2025",
      plate_number: "ق ه ل ١١١١ / Q H L 1111",
      city: {
        name: "Madinah",
        id: 5,
      },
      province: {
        name: "Madinah",
        id: 4,
      },
      usage: "refrigerator equipped",
      capacity: 5000,
      capacity_unit: "kilogram",
      vin: "WDFYD56E4LT890123",
    },
  ];

  return (
    <>
      <Header
        title={"Cars Management"}
        activeItem={"cars"}
        leftTitle={
          <div>
            <span>Number of Cars: {cars?.length || 5}</span>
            <span></span>
          </div>
        }
      />
      <ContentCard
        add={
          <AddCar
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            provinces={provinces}
            setCities={setCities}
            cities={cities}
            carTypes={cars?.extra?.car_types || []}
            usage={cars?.extra?.usage || []}
            capacity_unit={cars?.extra?.capacity_unit || []}
            year_range={cars?.extra?.year_range || {}}
            brands={brands}
            models={models}
            showManuFactoringYearsByCarModel={showManuFactoringYearsByCarModel}
            getCarsBrands={getCarsBrands}
            getCarsModels={getCarsModels}
            onAddCar={onAddCar}
            addCarStates={addCarStates}
            onAddCarValues={onAddCarValues}
            handleAddCarState={handleAddCarState}
          />
        }
        filter={
          <FilterCar
            filters={filters}
            setFilters={setFilters}
            getCarsReport={getCarsReport}
            onChangeFilters={onChangeFilters}
            provinces={provinces}
            cities={cities}
            setCities={setCities}
            carTypes={cars?.extra?.car_types || []}
            year_range={cars?.extra?.year_range || {}}
            brands={brands}
            models={models}
            getCarsBrands={getCarsBrands}
            getCarsModels={getCarsModels}
            getCars={getCars}
            cars={cars}
          />
        }
      >
        <Loading isLoading={loading}>
          <Table
            dataSource={data || []}
            size="middle"
            scroll={{ x: 640 }}
            pagination={{
              position: ["bottomCenter"],
              current: cars?.pagination?.page,
              pageSize: cars?.pagination?.limit,
              total: cars?.pagination?.count,
              onChange: changePage,
            }}
          >
            <Column
              title={"#"}
              dataIndex="index"
              key="index"
              render={(_value, _item, index) => <>{index + 1}</>}
            />
            <Column
              title={"City"}
              dataIndex="city"
              key="city"
              render={(city, data) => (
                <>
                  <small className="color-promotion-s1 mr-10 ml-5">
                    [{data.province.name}]
                  </small>
                  <span className="mx-10">{city.name}</span>
                </>
              )}
            />
            <Column
              title={"Type"}
              render={(car) => <>{car?.type}</>}
              dataIndex="car"
              key="car"
            />
            <Column
              title={"Model"}
              render={(car) => <>{car.name}</>}
              dataIndex="car"
              key="car"
            />
            <Column
              title={"Brand"}
              render={(car) => <>{car.brand}</>}
              dataIndex="car"
              key="car"
            />
            <Column
              title={"Year"}
              render={(year) => <>{year}</>}
              dataIndex="year"
              key="year"
            />
            <Column
              title={"Car Usage"}
              render={(usage) => <>{usage}</>}
              dataIndex="usage"
              key="usage"
            />
            <Column
              title={"Car Capacity"}
              dataIndex="capacity"
              key="capacity"
              render={(capacity, data) =>
                capacity && (
                  <>
                    {capacity}{" "}
                    {cars?.extra &&
                      cars?.extra?.capacity_unit.find(
                        (capacity_unit) =>
                          capacity_unit[0] === data.capacity_unit
                      )[1]}
                  </>
                )
              }
            />
            <Column title={"VIN"} dataIndex="vin" key="vin" />
            <Column
              title={"Plate Number"}
              render={(plate_number) => (
                // <PlateNumberComponent data={plate_number} />
                <span>{plate_number}</span>
              )}
              dataIndex="plate_number"
              key="plate_number"
            />
            <Column
              title="Actions"
              render={(_v, data, index) => (
                <div className="flex-row flex-wrap w-100">
                  <Button
                    className="button-white w"
                    onClick={() => setIsEditModalOpen(index)}
                  >
                    <img src={Edit} width="25px" alt="" />
                  </Button>
                  <EditCar
                    data={data}
                    carTypes={cars?.extra?.car_types || []}
                    usage={cars?.extra?.usage || []}
                    capacity_unit={cars?.extra?.capacity_unit || []}
                    year_range={cars?.extra?.year_range || {}}
                    editState={editState}
                    setEditState={setEditState}
                    isModalOpen={isEditModalOpen === index}
                    setIsModalOpen={setIsEditModalOpen}
                    showManuFactoringYearsByCarModel={
                      showManuFactoringYearsByCarModel
                    }
                    provinces={provinces}
                    cities={cities}
                    setCities={setCities}
                    models={models}
                    setModels={setModels}
                    brands={brands}
                    setBrands={setBrands}
                    getCarsBrands={getCarsBrands}
                    getCarsModels={getCarsModels}
                    onEditCar={onEditCar}
                  />
                </div>
              )}
            />
          </Table>
        </Loading>
      </ContentCard>
    </>
  );
};
